import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import TimesheetService from '../../components/timesheet/TimesheetService';

const initialState = {
    data: {},
    columnConfig: [],
    status: 'idle'

};

export const fetchProject = createAsyncThunk('project', async () => {
    const response = await TimesheetService.getProjects(true);
    return response;
});

export const ProjectSlice = createSlice({
    name: 'project',
    initialState,
    reducers: {
        addProjectConfig: (state, action) => {
            const configs = action.payload;
            let configsToStore = [];
            configs.forEach((config) => {
                configsToStore.push({
                    ...config,
                    key: config.columnCode,
                    options: config.options ? config.options : []
                });
            });
            state.columnConfig = configsToStore;
        },
        addColumnToProjectConfig: (state, action) => {
            state.columnConfig = [...state.columnConfig, action.payload];
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchProject.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchProject.fulfilled, (state, action) => {
                state.status = 'idle';
                state.data = action.payload;
            })

    }
});


export const selectProject = (state) => state.project.data;
